import moment, { unitOfTime } from 'moment'
import Decimal from 'decimal.js/decimal'

import { CouponDataType } from '@/modules/base/components/modal/upgrade-modal/order-overview/summary/overview-summary'
import { ShoppingCartItems } from '@/modules/moduleSubscription/types/ShoppingCart'
import { Vat } from '@/modules/moduleSubscription/components/_helpers/getVat1Germany'
import calculatePrice from '@/modules/moduleSubscription/components/_helpers/calculatePrice'
import { dateConstants } from '@/modules/base/util/constants'

const sumDefaultValues = {
  totalNet: 0,
  totalGross: 0,
  totalDiscount: 0,
  totalVat: 0,
}

// the VAT rate the sums are based on is returned as well - the checkout labels the VAT line with it
type Sums = typeof sumDefaultValues & { vatPercent: number }

const getSums = (items: ShoppingCartItems, vat1Germany: Vat, couponCode?: CouponDataType, period?: string): Sums => {
  return Object.keys(items).reduce((result, type) => {
    result = Object.values(items[type]).reduce((innerResult, item) => {
      let totalDiscount = 0
      const priceValues = item.prices?.find(price => price.period === (period || item.paymentIntervalOfSubscription))?.values?.[0]
      const { pricePerDuration, duration } = priceValues
      const divideFactorForMonth = pricePerDuration && duration
        ? Math.round(moment().add(duration, period as unitOfTime.DurationConstructor).diff(moment(), 'months', true))
        : 1

      if (pricePerDuration) {
        const price = calculatePrice(priceValues, item.type, period)
        const adjustedPrice = period === dateConstants.MONTH ? new Decimal(price).dividedBy(divideFactorForMonth).toDP(2).toNumber() : price

        if (couponCode && (item.isProductItem || item.type) && item.name === couponCode?.subscriptionType) {
          totalDiscount = couponCode.type === 'amount'
            ? parseFloat(couponCode?.amount)
            : parseFloat(couponCode?.amount) / 100 * price
          innerResult.totalDiscount = totalDiscount > price ? price : totalDiscount
        }

        innerResult.totalNet = new Decimal(innerResult.totalNet).plus(new Decimal(adjustedPrice).times(item.count).toDP(2).toNumber()).toDP(2).toNumber()
      }
      return innerResult
    }, { ...result })

    const vatCalc = new Decimal(result.vatPercent).dividedBy(100).plus(1)
    const adjustedNet = result.totalNet - result.totalDiscount >= 0 ? result.totalNet - result.totalDiscount : 0
    result.totalGross = new Decimal(adjustedNet).times(vatCalc).toDP(2).toNumber()
    result.totalVat = new Decimal(result.totalGross - adjustedNet).toDP(2).toNumber()
    return result
  }, { ...sumDefaultValues, vatPercent: vat1Germany?.value || 19 })
}

export default getSums
